import type { Optional } from '@festina-life/core'
import { stringUtils } from '@festina-life/core'
import type { CommandActionVariantOrSimulation } from '@festina-life/ui/theme'

import type { AnyCommandVersion } from './types'

export const shouldShowSimulationAndAllowFetchForFrame = ({
  commandActionVariant,
  isAllowedToDoCalculation,
  commandVersion,
}: {
  isAllowedToDoCalculation: boolean | undefined
  commandActionVariant: CommandActionVariantOrSimulation
  commandVersion: Optional<AnyCommandVersion>
}) => {
  const isApprovalPending =
    !!commandVersion?.commandPendingProcessingVersion?.approvalPending

  return (
    !!isAllowedToDoCalculation &&
    ((isApprovalPending &&
      stringUtils.strictIncludes(commandActionVariant, ['read'])) ||
      stringUtils.strictIncludes(commandActionVariant, [
        'create',
        'update',
        'approve',
        'simulationOnly',
      ]))
  )
}
